import {Outlet, Navigate, useLocation} from "react-router-dom"
import userInfo from "../pages/Common/userInfo"
import Hub from "../layout/Hub"

type RequiredAuthProps = {
    /** Where to send an unauthenticated visitor; defaults to the commissioning lane. */
    authPath?: string
}

const RequiredAuth = ({ authPath = "/commissioning-form/auth" }: RequiredAuthProps) => {
    const token = userInfo("access_token")

    const location = useLocation()

    return (
        <>
            {token ? (
                <Hub>
                    <Outlet />
                </Hub>
            ) : (
                <Navigate to={authPath} replace state={{from: location}} />
            )}
        </>
    )
}

export default RequiredAuth
